import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Accordion from './Accordion';
import { accordionData } from './Content';

const FriendlyQuestions = () => {
  const { t } = useTranslation('pricing');
  return (
    <div style={{ margin: '2rem auto', width: '100%' }}>
      <h1 className="text-center mb-1">{t('pricing:FAQ')}</h1>
      <div>
        {accordionData.map(({ title, content, key }) => (
          <Accordion key={key} title={t(title)} content={t(content)} />
        ))}
      </div>
    </div>
  );
};

export default FriendlyQuestions;
